module.exports = __webpack_public_path__ + "img/pc_leaf_R.7abef8e.webp";